<template>
    <div>
        <ui5-button @click="add()">Werkposttype toevoegen</ui5-button>
        <table v-if="workstationTypes && workstations && workstationScreens">
            <tbody v-for="type in workstationTypes" :key="type.id">
                <tr class="general">
                    <td>{{ type.externalName }}</td>
                    <td class="actions">
                        <i @click="edit(type)" class="fa fa-pencil"></i>
                        <i @click="remove(type)" class="fa fa-trash"></i>
                        <i @click="addWorkstation(type)" class="fa fa-plus"></i>
                    </td>
                </tr>
                <template v-for="station in workstations[type.id + ''] || []">
                    <tr class="station-item">
                        <td>
                            <span class="bullet">&cir;</span>
                            {{ station.label }}
                        </td>
                        <td class="actions">
                            <i
                                @click="editWorkstation(station)"
                                class="fa fa-pencil"></i>
                            <i
                                @click="removeWorkstation(station)"
                                class="fa fa-trash"></i>
                            <i
                                @click="addWorkstationScreen(station)"
                                class="fa fa-plus"></i>
                        </td>
                    </tr>

                    <tr
                        class="screen-item"
                        v-for="screen in workstationScreens[station.id + ''] ||
                        []">
                        <td>
                            <span class="bullet">&#9679;</span>
                            Werkpost {{ screen.producttypeLabel }}
                        </td>
                        <td class="actions">
                            <i
                                @click="editWorkstationScreen(screen)"
                                class="fa fa-pencil"></i>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
import workstationApi from '../../api/workstation';
import workstationScreenApi from '../../api/workstationScreen';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../../dialogs';

export default {
    props: [],
    data() {
        return {
            workstationTypes: null,
            workstations: null,
            workstationScreens: null,
        };
    },
    mounted() {
        this.load();
    },

    methods: {
        addWorkstation(type) {
            this.$router.push('addworkstation?typeId=' + type.id);
        },
        removeWorkstation(workstation) {
            showConfirmDialog({
                title: 'Werkpost verwijderen',
                content: 'Weet u zeker dat u deze werkpost wilt verwijderen?',
                confirm: () => {
                    workstationApi
                        .removeById(workstation.id)
                        .then(() => {
                            showInfoMessage(
                                'De werkpost werd verwijderd',
                                () => {
                                    this.load();
                                }
                            );
                        })
                        .catch(() => {
                            showErrorMessage(
                                'Onbekende fout bij het verwijderen van de werkpost',
                                () => {
                                    this.load();
                                }
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: 'Ja',
                cancelButton: 'Nee',
            });
        },
        editWorkstation(workstation) {
            this.$router.push('editworkstation/' + workstation.id);
        },
        add() {
            this.$router.push('addworkstationtype');
        },
        load() {
            workstationApi
                .fetchAllTypes('externalName', false)
                .then((response) => {
                    this.workstationTypes = response.data.data;
                });

            workstationApi.fetchAllWorkstations().then((response) => {
                this.workstations = response.data.data;
            });

            workstationScreenApi.fetchAll().then((response) => {
                this.workstationScreens = response.data.data;
            });
        },
        remove(type) {
            showConfirmDialog({
                title: 'Werkposttype verwijderen',
                content:
                    'Weet u zeker dat u dit werkposttype wilt verwijderen?',
                confirm: () => {
                    workstationApi
                        .removeType(type.id)
                        .then(() => {
                            showInfoMessage(
                                'Het werkposttype werd verwijderd',
                                () => {
                                    this.load();
                                }
                            );
                        })
                        .catch(() => {
                            showErrorMessage(
                                'Onbekende fout bij het verwijderen van het werkposttype',
                                () => {
                                    this.load();
                                }
                            );
                        });
                },
                closeOnCancel: true,
                closeOnOk: true,
                confirmButton: 'Ja',
                cancelButton: 'Nee',
            });
        },
        edit(type) {
            this.$router.push('editworkstationtype/' + type.id);
        },
        addWorkstationScreen(workstation) {
            this.$router.push(
                'addworkstationscreen?workstationId=' + workstation.id
            );
        },
        editWorkstationScreen(workstationScreen) {
            this.$router.push('editworkstationscreen/' + workstationScreen.id);
        },
    },
};
</script>
